// extracted by mini-css-extract-plugin
export default {"header":"WSRecentSearches-module_header-OhKWD","item":"WSRecentSearches-module_item-jhE91","clearButton":"WSRecentSearches-module_clearButton-yvM9Q"};